/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetReport$Params {
   report_id: string;

   /**
    * Report locale (en/uz)
    */
   locale?: string;

   /**
    * Report format (csv/json)
    */
   format?: string;

   /**
    * End date in format YYYY-MM-DD (exclusive)
    */
   date?: string;
}

export function getReport(
   http: HttpClient,
   rootUrl: string,
   params: GetReport$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<any>> {
   const rb = new RequestBuilder(rootUrl, getReport.PATH, 'get');
   if (params) {
      rb.path('report_id', params.report_id, {});
      rb.query('locale', params.locale, {});
      rb.query('format', params.format, {});
      rb.query('date', params.date, {});
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<any>;
      })
   );
}

getReport.PATH = '/api/weather/reports/{report_id}';
